import { render } from "./MonthTarget.vue?vue&type=template&id=2f8fb33c&scoped=true"
import script from "./MonthTarget.vue?vue&type=script&lang=js"
export * from "./MonthTarget.vue?vue&type=script&lang=js"

import "./MonthTarget.vue?vue&type=style&index=0&id=2f8fb33c&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8fb33c"]])

export default __exports__